// Redux & Action
import { useSelector } from 'react-redux';

// @Utility
import currencyFormat from "@utility/numbers/currencyFormat";

// Component
import Grid from '@mui/material/Grid';
import ImageShow from "views/components/ImageShow";

// Style & CSS
import "assets/css/Credit.css";

export default function Point({ width }) {
    const homeData = useSelector(state => state.reduxHome.result);

    return (
            homeData !== null && (
            homeData.wallets !== null && (
                <div className="narbarPoint center contentMediumMarginTop" style={width !== null && { width: `${width}%` }}>
                    <div className="narbarPointPadding">
                        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                            <Grid item>
                                <div className="textCredit">
                                    เเต้มสะสม
                                </div>
                            </Grid>
                            <Grid item>
                                <div className="textCredit textColor">
                                    {
                                        currencyFormat(homeData.wallets[0].balance, 2)
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )
        )
    );
}